import { tagGroups } from '../tagGroups';
import { tags } from '../tags';

const FOOD_FORMAT_TAG_IDS = new Set<number>([
  tags.ReadyToEat,
  tags.HeatAndEat,
  tags.ChefStyleRecipes,
]);

// QuickRecipes (817), TwentyMinutesOrLess (189), and FamilyMeals are
// deliberately suppressed as swipe badge copy.
const NON_BADGEABLE_TAG_IDS = new Set<number>([
  tags.QuickRecipes,
  tags.TwentyMinutesOrLess,
  tags.FamilyMeals,
]);

// tagGroups.certificates (10) is the "Qualities" group despite the constant name.
const GROUP_RANK: Record<number, number> = {
  [tagGroups.nutrition]: 2,
  [tagGroups.certificates]: 3,
};

export function tagBadgePriority({
  tagId,
  tagGroupId,
}: {
  tagId: number;
  tagGroupId: number | null;
}): number {
  if (FOOD_FORMAT_TAG_IDS.has(tagId)) return 1;
  if (tagGroupId === null) return Number.MAX_SAFE_INTEGER;
  return GROUP_RANK[tagGroupId] ?? Number.MAX_SAFE_INTEGER;
}

export function isTagBadgeable({ tagId }: { tagId: number }): boolean {
  return !NON_BADGEABLE_TAG_IDS.has(tagId);
}

// A badge labels one dish, so these tags' plural API names read wrong on a
// single card: "Chef-style recipes" becomes "Chef-style recipe". Only the
// trailing "s" is dropped, so the API keeps ownership of the wording and
// casing — which is not consistent across surfaces ("Chef-Style Recipes" in
// preference options, "Chef-style recipes" in the quiz tile).
// FamilyMeals is listed deliberately even though NON_BADGEABLE_TAG_IDS above
// currently keeps its badge off the card: the rule is inert until that
// suppression is lifted, and having it here means the badge comes back
// singular rather than plural when it does.
const SINGULAR_BADGE_TAG_IDS = new Set<number>([
  tags.ChefStyleRecipes,
  tags.FamilyMeals,
]);

export function tagBadgeLabel({
  tagId,
  name,
}: {
  tagId: number;
  name: string;
}): string {
  if (!SINGULAR_BADGE_TAG_IDS.has(tagId)) return name;
  return name.endsWith('s') ? name.slice(0, -1) : name;
}
